import { openSignInModal } from '../templates/_shared/ui-components/SignInModal/utils';
import { IS_NATIVE_APP_CLIENT } from './helpers';
import { prependLocaleToPath } from './localization';
import { IS_PRESUMABLY_EXISTING_CUSTOMER } from './constants';

export const setupAuthHandler = () => {
  const conditionallyShowAuthModal = () => {
    const hash = window.location.hash;
    if (hash !== '#signIn' && hash !== '#startNow') return;

    // Use history.replaceState to remove the hash
    window.history.replaceState(null, document.title, window.location.pathname + window.location.search);

    // Open auth modal with the appropriate tab selected
    if (IS_NATIVE_APP_CLIENT) {
      window.location.href = prependLocaleToPath(`/account/login?newUser=${!IS_PRESUMABLY_EXISTING_CUSTOMER}`);
    } else {
      const tab = hash === '#startNow' ? 'create-account' : 'sign-in';
      openSignInModal({ returnUrl: window.location.href, tab: tab });
    }
  };

  window.addEventListener('hashchange', conditionallyShowAuthModal);
};
